module.exports = __webpack_public_path__ + "static/media/add.db06e81d.svg";